import { render, staticRenderFns } from "./DouYinReleaseRecord.vue?vue&type=template&id=4961d8b9&scoped=true"
import script from "./DouYinReleaseRecord.vue?vue&type=script&lang=js"
export * from "./DouYinReleaseRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4961d8b9",
  null
  
)

export default component.exports